<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png">
    <br><br>
    <v-btn class="red" dark @click="logout">Salir</v-btn>
  </div>
</template>

<script>
import cookie from 'vue-cookie';
export default {
  name: 'Home',
  components: {
    
  },

  methods: {
    logout: function(){
      this.$router.push({name:'Logout'})
    }
  },
  
  beforeMount() {
    let token = cookie.get('token')

    if(token ===  '' || token === null ){
     
      this.$router.push({name:'Login'});
    }

     console.log("Mi token ",token);
  },

}
</script>
